import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function CoachingSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-5xl mx-auto px-4 py-6 md:py-8">
                    {/* Header: icon box + title/subtitle */}
                    <div className="flex items-center gap-4 mb-6 md:mb-8">
                        <Skeleton width={52} height={52} borderRadius={12} />
                        <div className="flex-1">
                            <Skeleton width={180} height={26} />
                            <Skeleton width={240} height={14} className="mt-2" />
                        </div>
                    </div>

                    {/* Primary card */}
                    <div className={`${cardCls} p-6 mb-4`}>
                        <div className="flex items-center gap-4 mb-4">
                            <Skeleton circle width={56} height={56} />
                            <div className="flex-1">
                                <Skeleton width="50%" height={18} />
                                <Skeleton width="35%" height={13} className="mt-2" />
                            </div>
                        </div>
                        <Skeleton count={2} />
                        <div className="mt-4 flex gap-2">
                            <Skeleton width={130} height={38} borderRadius={8} />
                            <Skeleton width={130} height={38} borderRadius={8} />
                        </div>
                    </div>

                    <div className={`${cardCls} p-6`}>
                        <Skeleton width="40%" height={18} className="mb-4" />
                        <Skeleton count={3} />
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
